import React from "react";
import LocationBanner from "components/locationBanner/index";
import AcadmicInstruction from "components/reusableComponents/AcadmicInstruction";
import LocalizationMidText from "components/reusableComponents/localizationMidText";
import GlobalLeader from "components/reusableComponents/globalLeader";
import { Data, MoreData, CardData, FaqData } from "./config";
import WhatsAppComp from "components/reusableComponents/whatsappComp";
import CommonUse from "components/LocationReusableComp/commonuse";
import TranslationServiceCards from "components/reusableComponents/translationServiceCards";
import TechnicalDocument from "components/reusableComponents/technicalDocument";
import CaseStudiesCard from "components/reusableComponents/caseStudiesCard";
import WhatChooseUs from "components/homepage/whyChooseUs";
import Reviews from "components/homepage/reviews";
import TranslateAgency from "components/homepage/translateAgency";

export default function DocumentTranslationServices() {
  return (
    <div>
      <LocationBanner
        title="Document Translation Services"
        backgroundCol="bg-midBlue"
        content="Are you looking to translate your documents? Document translation services are at Tomedes' core expertise. Our global teams of expert linguists transform each document into a multitude of languages, with a selection of over 120 languages and 950+ language pairs, paired with fast delivery, a 1-year guarantee, and 24/7 customer support, at Tomedes."
        formOrangeHead="Get in touch "
        formWhiteHead=" with our document translation company"
      />
      {/* <AcadmicInstruction
        head="Our document translation services are "
        content="We're trusted by Fortune 500 companies and small and medium corporations alike. Put your trust in Tomedes today. Here are some of our 95,000+ satisfied business partners."
        colorHead="trusted"
        secondHead=""
        thirdColorHead="text-LightBlue"
        thirdHead="by companies and individuals worldwide"
      /> */}
      <TranslateAgency
        head="Our document translation services are"
        colorHead="trusted"
        lastHeadText="by companies and individuals worldwide"
        content="We're trusted by Fortune 500 companies and small and medium corporations alike. Put your trust in Tomedes today. Here are some of our 95,000+ satisfied business partners."
      />
      <LocalizationMidText
        fText="Tomedes furthers the global objectives of brands worldwide, providing"
        orangeMidText="document"
        content="translation solutions that broaden their horizons. We provide scalable and guaranteed business solutions that are delivered on time by our team of experts."
      />
      <GlobalLeader
        title
        detail
        data={Data}
        link
        colorHead
        link="/language-translation-service.php"
      />
      <WhatsAppComp
        backgroundCol="bg-midBlue"
        fHead="Connect"
        secondHead="with a document translator now"
        fHeadCol="text-orange"
        content="Get in touch with us in real-time, any time. Click the link to connect."
        whatsUp
      />
      <CommonUse
        backgroundCol="bg-darkBlue"
        colorTitleText="Document"
        colorTitle="text-orange"
        title="Translation for Your Every Need"
        data={MoreData}
        bottomBorderText
        BBH="Our Document Translation Services"
        BBC="Translating documents is Tomedes' core competence: your document's translation will be performed by expert linguists skilled in the required languages and specific subject matter."
        hColor="text-orange"
      />
      <TranslationServiceCards cardData={CardData} />
      <TechnicalDocument
        backgroundCol="bg-midBlue"
        secondHead="us your documents"
        para="Getting started with Tomedes is easy. Just send us the document(s) to be translated along with information about the languages needed, website links, and delivery deadlines. We'll respond immediately."
      />
      <CaseStudiesCard backgroundCol="bg-darkBlue" />
      <GlobalLeader
        data={FaqData}
        backgroundCol="bg-midBlue"
        FirstHead=" "
        secondHead=" "
        ColorHead="FAQs"
      />
      <WhatChooseUs backgroundCol="bg-darkBlue" />
      <Reviews backgroundCol="bg-midBlue" />
    </div>
  );
}
